/*
 * Milk Kitchen Helpers Library
 * Created: 2018-06-28
 * Version: 0.1.0
 * Copyright: 2018 Milk Kitchen Limited.
 * Author: Todd Hossack
 * Dependencies: jQuery, lodash
 */

if(typeof require === "function") {
    var _ = require('lodash');
    var $ = require('jquery');
}

class Helpers {
    
    /**
    * Finds a deeply nested value in an object using a dot notation path 
    * made of the relevant keys.
    * @param {object} data
    * @param {string} Path in dot notation
    * @param {mixed} Default value to return if null
    * @returns {mixed}
    */
    static data_get(data, key, def) {
        if (def === 'undefined') def = null;
        if (!data || (!key && key !== 0)) return def;
        var keys,res;
        if(_.isArray(key)) {
            keys = key;
        } else {
            key = key + '';	// Cast to string
            keys = key.split('.');
        }
        var res = data;
        for (var i = 0, k; res && (k = keys[i]); i++) {
            if (_.isObject(res) && k in res) {
                res = _.result(res, k);
            } else {
                res = null;
                if (i < (keys.length - 1)) break;
            }
        }
        return (res !== null) ? res : def;
    };

    /**
     * Sets a deeply nested value in an object using a dot notation path 
     * made of the relevant keys.
     * @param {object} data
     * @param {string} Path in dot notation
     * @param {mixed} Value to be set
     * @returns {boolean} Returns true for success or false if value could not be set
     */
    static data_set(data, key, val) {
        if(!_.isObject(data) || !_.isString(key) || key.length === 0) return false;
        var keys;
        
        if(_.isArray(key)) {
            keys = key;
        } else {
            key = key + '';	// Cast to string
            keys = key.split('.');
        }

        var item = data;
        // Iterate through key path, making objects as necessary
        for (var i = 0, k; item && (k = keys[i]); i++) {
            // If at the end of the path, set value
            if (i === (keys.length - 1)) {
                item[k] = val;
                break;
            }
            // Key is available and object
            if(_.has(item,k) && _.isObject(item[k])) {
                item = item[k];
            } 
            // Create the object
            else {
                item[k] = {};
                item = item[k];
            }
        }
        return true;
    };

    /**
     * Delete a deeply nested key in an object using a dot notation path 
     * made of the relevant keys.
     * @param {object} data
     * @param {string} Path in dot notation
     * @param {mixed} Default value to return if null
     * @returns {mixed}
     */
    static unset_data_key(data, key) {
        if (!data || (!key && key !== 0)) return false;
        key = key + '';	// Cast to string
        var keys = key.split('.');
        var item = data;
        for (var i = 0, k; item && (k = keys[i]); i++) {
            // Key is in object
            if (_.isObject(item) && k in item) {
                // If at the end of the path, delete key
                if (i === (keys.length - 1)) {
                    delete item[k];
                    return true;
                } else {
                    item = item[k];
                }
            } 
            // Key is not in object so give up
            else {
                return null;
            }
        }
        return null;
    };

    static arrayReplace(string, replacements) {
        for(var find in replacements){
            string = string.replace(find, replacements[find]);
        }
        return string;
    };

    /**
     * Creates key:value list from a collection.
     * Recursive if multi-dimensional.
     * @param array collection of objects, or keyed object. Keyed objects should
     * have option "keyField" set to false, to use existing keys
     * @param options: 
     *      keyField: string - May use a path using dot notation. Default: 'id'
     *      valueField: string|array - Path using dot notation or array of paths. Default: 'name'
     *      glue: string - Separator for joining array. Default: ' '
     * @returns object - hash with key value pairs
     */
    static makeList(collection, options) {
        var opts,arr,key,val,self=this,addItem,grouped=false,
            out = [];
        opts = _.defaults(options,{
           keyField: 'id',
           valueField: 'name',
           glue: ' ',
           keyed: false
        });

        _.forEach(collection,function(item,k) {
            grouped = false;
            key = (opts.keyField) ? self.data_get(item,opts.keyField) : k;
            if(_.isString(item)) {
                val = item;
            } else if(_.isArray(opts.valueField)) {
                // Combine value fields
                arr = _.reduce(opts.valueField,function(result,v) {
                    result.push(self.data_get(item,v));
                    return result;
                },[]);
                val = arr.join(opts.glue);
            } else {
                // Differentiate with grouped
                if(key && !_.has(item,opts.valueField) && _.isObject(item)) {
                    grouped = true;
                    val = key;
                } else {
                    val = self.data_get(item,opts.valueField);
                }
            }
            if(opts.keyed) {
                out[key] = (grouped) ? self.makeList(item,options) : val;
            } else {
                addItem = {
                    id: key,
                    text: val
                };
                
                if(grouped) {
                    addItem['options'] = self.makeList(item,options);
                }
                out.push(addItem);
            }
        });
       
        return out;
    }

    static makeLink(content,route,action,id,ext,options,params) {
        opts = _.defaults(options,{
           target: '_self',
           class: '',
           title: ''
        });
        var url = this.resourceUrl(route,action,id,ext);
        var html = '<a href="'+ url +'" target="'+ opts.target +'" title="'+ _.escape(opts.title) +'" >' + 
            this.escapeHtml(content) + '</a>';
        return html;
    }
    
	static makeUrl(url,replacements,params,fragment) {
        // Make substitutions
        if(!_.isEmpty(replacements)) {
            _.each(replacements,function(v,k) {
                if(v !== null) {
                    url = decodeURI(url);
                    url = encodeURI(url).replace('%7B'+ k +'%7D',v);
                }
            });
        }

        // Add query params
        if(!_.isEmpty(params)) {
            url += '?' + $.param(params);
        }
        
        if(fragment) {
            url += '#'+ fragment;    //@todo - sanitise
        }
        return url;
    };
	
	/**
     * Makes resource URL (CakePHP conventions), 
     * given route, and optional action and id parameters.
     * @param {String} route
     * @param {String} action
     * @param {Number} id
     * @todo - check/add trailing slash on route
     * @returns {String}
     */
    static resourceUrl(route,action,id,ext,params,fragment) {
        if(action && action !== 'index') {
            if(!_.includes(route,'{action}')) {
                route += '{action}';
            }
            if(id) {
                route += '/{id}'
            }
            
            if(typeof ext == 'string') {
                route += '.' + ext;
            }
        }
        return this.makeUrl(route,{action: action, id: id},params,fragment);
    };
	
    /**
     * Renders and array or collection as an HTML list.
     * @param Array arr
     * @returns {Helpers.arrayToUl.html|String}
     */
    static arrayToUl(arr) {
        var html = '<ul>';
        _.forEach(arr,function(item) {
            html += '<li>'+ item +'</li>';
        });
        html += '</ul>';
        return html;
    }
    /**
     * Capitalise first letter of word
     * @param String string
     * @returns String
     */
    static ucfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    
    
    static precise(el,precision) {
        el.value = (el.value !== '') ? Number(el.value).toFixed(precision) : '';
    };
    
    static truncateText(str, length, end) {
        if(!end) {
            end = '...';
        }
        if (str.length > length) {
          return str.substring(0, length - end.length) + end;
        } else {
          return str;
        }
    };

    static parseJson(str) {
        var json = '';
        try {
            json = JSON.parse(str);
        } catch(e) {
            console.log(e);
            console.trace();
        }
        
        return json;
    }
    /**
     * Removes escape slashes from json
     * @param {string} str
     * @returns {string}
     */
    static unescapeJson(str) {
        return str.replace(/\\/gi,'');   // Remove escape slashes
    }
    
    /**
     * Escapes HTML chars
     * @param {string} str
     * @returns {string}
     */
    static escapeHtml(text) {
        var map = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        };
        return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }
    
    /**
     * Ported from PHP helper function translateBoolean
     * @param {type} val
     * @returns {String}
     */
    static translateBoolean(val) {
        return (val) ? 'Yes' : 'No';
    }
    
    /**
     * Ported from PHP helper function translateBoolean
     * @param {type} val
     * @returns {String}
     */
    static translateResult(val) {
        var types = [
            {value: -10, label: 'Error'},
            {value: 0, label: 'Fail'},
            {value: 10, label: 'Retest'},
            {value: 20, label: 'Pass'},
        ];
        var type = _.find(types,function(t) {
            return (Number(val) === t.value);            
        });
        
        return (type) ? type.label : '';
    }
    
    /**
     * Ported from PHP helper function dateUserString
     * @param {String} date
     * @param {String,Object} user
     * @param {Boolean} parentheses
     * @returns {String}
     */
    static dateUserString(date,user,parentheses) {
        var userStr = _.isObject(user) ? this.data_get(user,'username') : user;
        var str = (date || userStr) ? [date,userStr].join(' ') : '';
        if(parentheses && str) {
            str = '('+ this.escapeHtml(str) +')';
        }
        return str;
    }
    
    /**
     * Ported from PHP helper function affirmativeHtml
     * @param {type} bool
     * @param {type} options
     * @returns {undefined}
     */
    static affirmativeHtml(bool,opts) {
        var options = _.defaults(opts,{
            positiveClass: 'success',
            positiveIcon:'fas fa-check-circle',
            negativeClass: 'warning',
            negativeIcon: 'fas fa-exclamation-triangle',
            spanClass: 'alert-text'
        });

        var statusClass = bool ? this.data_get(options,'positiveClass') : this.data_get(options,'negativeClass');
        var iconClass = bool ? this.data_get(options,'positiveIcon') : this.data_get(options,'negativeIcon');
        var title = bool ? this.data_get(options,'positiveTitle') : this.data_get(options,'negativeTitle');
        var dateUser = this.dateUserString(this.data_get(options,'date'),this.data_get(options,'user'));
        var details = (bool && dateUser) ? ' ('+ dateUser +')' : '';
        var iconTitle = (this.data_get(options,'iconTitle') || title);
        var combinedClass = (statusClass) ? options.spanClass +' '+ statusClass : '';
        var html = '<span class="envui-icon-text ' + combinedClass + '" title="' + iconTitle +'"><i class="'+ iconClass +'" title="' + iconTitle +'"></i>';
        if(title) {
            html += this.escapeHtml(title);
        }
        html += '</span>';
        if(details) {
            html += '<span class="envui-icon-text alert-text secondary">'+ this.escapeHtml(details) +'</span>';
        }
        var help = this.data_get(options,'help');
        if(help && help.length) {
            html += '<span class="help">'+ this.escapeHtml(options['help']) +'</span>';
        }
        
        return html;
    }
    
    /*
     * Numbers
     */
    /**
     * @deprecated: use formatNumber
     * @param {type} val - Number to format
     * @param {type} dec - Number of decimal places
     * @returns {undefined}
     */
    static numberFormat(val,dec,opts) {
        var options = _.defaults(_.clone(opts || {}),{
            decimals: dec || 0,
            dec_point: '.', //@todo
            thousands_sep: ',', //@todo
            signed: false   //@todo
        });
        
        return this.formatNumber(val,options);
        /*
        if(typeof val === 'null' 
        || typeof val === 'undefined' 
        || typeof val === 'object'
        || val === '') {
            return '';
        }
        if(typeof val !== "number") {
            val = Number(val);
        }
        var def = this.data_get(opts,'zero_decimals');
        if(typeof(def) !== 'undefined' && typeof(def) !== 'null' && val === 0) {
            return def;
        }
        return val.toLocaleString('en',{
            'minimumFractionDigits': dec,
            'maximumFractionDigits': dec
        });
        */
    }
    
    static formatNumber(val,opts) {
        if(typeof val === 'null' 
        || typeof val === 'undefined' 
        || typeof val === 'object'
        || val === '') {
            return '';
        }
        // Defaults
        var options = _.defaults(_.clone(opts || {}),{
            decimals: 0,
            dec_point: '.', //@todo
            thousands_sep: ',', 
            signed: false,   
            prefix: null,
            suffix: null
        });
        
        if(typeof val !== "number") {
            val = Number(val);
        }
        var def = this.data_get(opts,'zero_decimals');
        if(typeof(def) !== 'undefined' && typeof(def) !== 'null' && val === 0) {
            return def;
        }
        
        var str = val.toLocaleString('en',{
            'minimumFractionDigits': options.decimals,
            'maximumFractionDigits': options.decimals,
            'useGrouping': (options.thousands_sep && options.thousands_sep.length)
        });
        // Add sign for positive numbers
        if(options.signed && val > 0) {
            str = '+' + str;
        }
        // Prefix
        if(options.prefix) {
            str = options.prefix + str;
        }
        // Suffix
        if(options.suffix) {
            str += options.suffix;
        }
        return str;
    }
    
    static roundNumber(num,dec) {
        return Number(Math.round(num + 'e' + dec) + 'e-' + dec);
    }
    
    static sleep(ms) {
        var d = new $.Deferred(); 
        setTimeout(d.resolve, ms); 
        return d.promise();
    }
};

if(typeof module === "object" && typeof module.exports === "object") {
    var exports = module.exports = Helpers;
}


// WEBPACK FOOTER //
// ./client/src/js/lib/helpers.js